var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastCongratulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28418 13.9579C9.7137 14.017 10.3672 13.7646 10.8841 13.3693C11.1598 13.1575 11.4072 12.8977 11.5856 12.6354",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8348 7.8761C17.0752 9.04003 17.0535 10.2429 16.7713 11.3974C16.4891 12.5519 15.9535 13.6291 15.2033 14.5506C14.4532 15.4721 13.5073 16.2149 12.4344 16.7251C11.3615 17.2353 10.1885 17.4999 9.00067 17.4999C7.81278 17.4999 6.63981 17.2353 5.56692 16.7251C4.49403 16.2149 3.54816 15.4721 2.798 14.5506C2.04783 13.6291 1.5122 12.5519 1.23 11.3974C0.947797 10.2429 0.926109 9.04003 1.16651 7.8761",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.097 5.80986C15.4213 4.51028 14.402 3.42119 13.1503 2.66123C11.8985 1.90128 10.4624 1.49961 8.99821 1.5C7.53407 1.49961 6.09789 1.90128 4.84617 2.66123C3.59444 3.42119 2.57517 4.51028 1.89941 5.80986",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.73348V5.80994H8.99969V6.73348C8.99969 7.79488 8.57828 8.8128 7.82816 9.56333C7.07804 10.3138 6.06067 10.7355 4.99984 10.7355C3.93902 10.7355 2.92164 10.3138 2.17153 9.56333C1.42141 8.8128 1 7.79488 1 6.73348Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 6.73348V5.80994H16.9987V6.73348C16.9987 7.79488 16.5773 8.8128 15.8272 9.56333C15.0771 10.3138 14.0597 10.7355 12.9989 10.7355C11.938 10.7355 10.9207 10.3138 10.1706 9.56333C9.42043 8.8128 8.99902 7.79488 8.99902 6.73348Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCongratulations);
export default __webpack_public_path__ + "static/media/toast-congratulations.961a8e5775072e6715f5bb2d1d7f96af.svg";
export { ForwardRef as ReactComponent };